import _defineProperty from "/codebuild/output/src526598370/src/actions-runner/_work/www-lwb-org-au/www-lwb-org-au/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _possibleConstructorReturn from "/codebuild/output/src526598370/src/actions-runner/_work/www-lwb-org-au/www-lwb-org-au/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/codebuild/output/src526598370/src/actions-runner/_work/www-lwb-org-au/www-lwb-org-au/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _inherits from "/codebuild/output/src526598370/src/actions-runner/_work/www-lwb-org-au/www-lwb-org-au/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _classCallCheck from "/codebuild/output/src526598370/src/actions-runner/_work/www-lwb-org-au/www-lwb-org-au/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/codebuild/output/src526598370/src/actions-runner/_work/www-lwb-org-au/www-lwb-org-au/node_modules/@babel/runtime/helpers/esm/createClass.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import { ElementType, isTag as isTagRaw } from "domelementtype";
/**
 * This object will be used as the prototype for Nodes when creating a
 * DOM-Level-1-compliant structure.
 */
export var Node = /*#__PURE__*/function () {
  function Node() {
    _classCallCheck(this, Node);
    /** Parent of the node */
    this.parent = null;
    /** Previous sibling */
    this.prev = null;
    /** Next sibling */
    this.next = null;
    /** The start index of the node. Requires `withStartIndices` on the handler to be `true. */
    this.startIndex = null;
    /** The end index of the node. Requires `withEndIndices` on the handler to be `true. */
    this.endIndex = null;
  }
  // Read-write aliases for properties
  /**
   * Same as {@link parent}.
   * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
   */
  return _createClass(Node, [{
    key: "parentNode",
    get: function get() {
      return this.parent;
    },
    set: function set(parent) {
      this.parent = parent;
    }
    /**
     * Same as {@link prev}.
     * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
     */
  }, {
    key: "previousSibling",
    get: function get() {
      return this.prev;
    },
    set: function set(prev) {
      this.prev = prev;
    }
    /**
     * Same as {@link next}.
     * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
     */
  }, {
    key: "nextSibling",
    get: function get() {
      return this.next;
    },
    set: function set(next) {
      this.next = next;
    }
    /**
     * Clone this node, and optionally its children.
     *
     * @param recursive Clone child nodes as well.
     * @returns A clone of the node.
     */
  }, {
    key: "cloneNode",
    value: function cloneNode() {
      var recursive = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      return _cloneNode(this, recursive);
    }
  }]);
}();
/**
 * A node that contains some data.
 */
export var DataNode = /*#__PURE__*/function (_Node) {
  /**
   * @param data The content of the data node
   */
  function DataNode(data) {
    var _this;
    _classCallCheck(this, DataNode);
    _this = _callSuper(this, DataNode);
    _this.data = data;
    return _this;
  }
  /**
   * Same as {@link data}.
   * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
   */
  _inherits(DataNode, _Node);
  return _createClass(DataNode, [{
    key: "nodeValue",
    get: function get() {
      return this.data;
    },
    set: function set(data) {
      this.data = data;
    }
  }]);
}(Node);
/**
 * Text within the document.
 */
export var Text = /*#__PURE__*/function (_DataNode) {
  function Text() {
    var _this2;
    _classCallCheck(this, Text);
    _this2 = _callSuper(this, Text, arguments);
    _this2.type = ElementType.Text;
    return _this2;
  }
  _inherits(Text, _DataNode);
  return _createClass(Text, [{
    key: "nodeType",
    get: function get() {
      return 3;
    }
  }]);
}(DataNode);
/**
 * Comments within the document.
 */
export var Comment = /*#__PURE__*/function (_DataNode2) {
  function Comment() {
    var _this3;
    _classCallCheck(this, Comment);
    _this3 = _callSuper(this, Comment, arguments);
    _this3.type = ElementType.Comment;
    return _this3;
  }
  _inherits(Comment, _DataNode2);
  return _createClass(Comment, [{
    key: "nodeType",
    get: function get() {
      return 8;
    }
  }]);
}(DataNode);
/**
 * Processing instructions, including doc types.
 */
export var ProcessingInstruction = /*#__PURE__*/function (_DataNode3) {
  function ProcessingInstruction(name, data) {
    var _this4;
    _classCallCheck(this, ProcessingInstruction);
    _this4 = _callSuper(this, ProcessingInstruction, [data]);
    _this4.name = name;
    _this4.type = ElementType.Directive;
    return _this4;
  }
  _inherits(ProcessingInstruction, _DataNode3);
  return _createClass(ProcessingInstruction, [{
    key: "nodeType",
    get: function get() {
      return 1;
    }
  }]);
}(DataNode);
/**
 * A `Node` that can have children.
 */
export var NodeWithChildren = /*#__PURE__*/function (_Node2) {
  /**
   * @param children Children of the node. Only certain node types can have children.
   */
  function NodeWithChildren(children) {
    var _this5;
    _classCallCheck(this, NodeWithChildren);
    _this5 = _callSuper(this, NodeWithChildren);
    _this5.children = children;
    return _this5;
  }
  // Aliases
  /** First child of the node. */
  _inherits(NodeWithChildren, _Node2);
  return _createClass(NodeWithChildren, [{
    key: "firstChild",
    get: function get() {
      var _a;
      return (_a = this.children[0]) !== null && _a !== void 0 ? _a : null;
    }
    /** Last child of the node. */
  }, {
    key: "lastChild",
    get: function get() {
      return this.children.length > 0 ? this.children[this.children.length - 1] : null;
    }
    /**
     * Same as {@link children}.
     * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
     */
  }, {
    key: "childNodes",
    get: function get() {
      return this.children;
    },
    set: function set(children) {
      this.children = children;
    }
  }]);
}(Node);
export var CDATA = /*#__PURE__*/function (_NodeWithChildren) {
  function CDATA() {
    var _this6;
    _classCallCheck(this, CDATA);
    _this6 = _callSuper(this, CDATA, arguments);
    _this6.type = ElementType.CDATA;
    return _this6;
  }
  _inherits(CDATA, _NodeWithChildren);
  return _createClass(CDATA, [{
    key: "nodeType",
    get: function get() {
      return 4;
    }
  }]);
}(NodeWithChildren);
/**
 * The root node of the document.
 */
export var Document = /*#__PURE__*/function (_NodeWithChildren2) {
  function Document() {
    var _this7;
    _classCallCheck(this, Document);
    _this7 = _callSuper(this, Document, arguments);
    _this7.type = ElementType.Root;
    return _this7;
  }
  _inherits(Document, _NodeWithChildren2);
  return _createClass(Document, [{
    key: "nodeType",
    get: function get() {
      return 9;
    }
  }]);
}(NodeWithChildren);
/**
 * An element within the DOM.
 */
export var Element = /*#__PURE__*/function (_NodeWithChildren3) {
  /**
   * @param name Name of the tag, eg. `div`, `span`.
   * @param attribs Object mapping attribute names to attribute values.
   * @param children Children of the node.
   */
  function Element(name, attribs) {
    var _this8;
    var children = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
    var type = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : name === "script" ? ElementType.Script : name === "style" ? ElementType.Style : ElementType.Tag;
    _classCallCheck(this, Element);
    _this8 = _callSuper(this, Element, [children]);
    _this8.name = name;
    _this8.attribs = attribs;
    _this8.type = type;
    return _this8;
  }
  _inherits(Element, _NodeWithChildren3);
  return _createClass(Element, [{
    key: "nodeType",
    get: function get() {
      return 1;
    }
    // DOM Level 1 aliases
    /**
     * Same as {@link name}.
     * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
     */
  }, {
    key: "tagName",
    get: function get() {
      return this.name;
    },
    set: function set(name) {
      this.name = name;
    }
  }, {
    key: "attributes",
    get: function get() {
      var _this9 = this;
      return Object.keys(this.attribs).map(function (name) {
        var _a, _b;
        return {
          name: name,
          value: _this9.attribs[name],
          namespace: (_a = _this9["x-attribsNamespace"]) === null || _a === void 0 ? void 0 : _a[name],
          prefix: (_b = _this9["x-attribsPrefix"]) === null || _b === void 0 ? void 0 : _b[name]
        };
      });
    }
  }]);
}(NodeWithChildren);
/**
 * @param node Node to check.
 * @returns `true` if the node is a `Element`, `false` otherwise.
 */
export function isTag(node) {
  return isTagRaw(node);
}
/**
 * @param node Node to check.
 * @returns `true` if the node has the type `CDATA`, `false` otherwise.
 */
export function isCDATA(node) {
  return node.type === ElementType.CDATA;
}
/**
 * @param node Node to check.
 * @returns `true` if the node has the type `Text`, `false` otherwise.
 */
export function isText(node) {
  return node.type === ElementType.Text;
}
/**
 * @param node Node to check.
 * @returns `true` if the node has the type `Comment`, `false` otherwise.
 */
export function isComment(node) {
  return node.type === ElementType.Comment;
}
/**
 * @param node Node to check.
 * @returns `true` if the node has the type `ProcessingInstruction`, `false` otherwise.
 */
export function isDirective(node) {
  return node.type === ElementType.Directive;
}
/**
 * @param node Node to check.
 * @returns `true` if the node has the type `ProcessingInstruction`, `false` otherwise.
 */
export function isDocument(node) {
  return node.type === ElementType.Root;
}
/**
 * @param node Node to check.
 * @returns `true` if the node has children, `false` otherwise.
 */
export function hasChildren(node) {
  return Object.prototype.hasOwnProperty.call(node, "children");
}
/**
 * Clone a node, and optionally its children.
 *
 * @param recursive Clone child nodes as well.
 * @returns A clone of the node.
 */
function _cloneNode(node) {
  var recursive = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var result;
  if (isText(node)) {
    result = new Text(node.data);
  } else if (isComment(node)) {
    result = new Comment(node.data);
  } else if (isTag(node)) {
    var children = recursive ? cloneChildren(node.children) : [];
    var clone = new Element(node.name, _objectSpread({}, node.attribs), children);
    children.forEach(function (child) {
      return child.parent = clone;
    });
    if (node.namespace != null) {
      clone.namespace = node.namespace;
    }
    if (node["x-attribsNamespace"]) {
      clone["x-attribsNamespace"] = _objectSpread({}, node["x-attribsNamespace"]);
    }
    if (node["x-attribsPrefix"]) {
      clone["x-attribsPrefix"] = _objectSpread({}, node["x-attribsPrefix"]);
    }
    result = clone;
  } else if (isCDATA(node)) {
    var _children = recursive ? cloneChildren(node.children) : [];
    var _clone = new CDATA(_children);
    _children.forEach(function (child) {
      return child.parent = _clone;
    });
    result = _clone;
  } else if (isDocument(node)) {
    var _children2 = recursive ? cloneChildren(node.children) : [];
    var _clone2 = new Document(_children2);
    _children2.forEach(function (child) {
      return child.parent = _clone2;
    });
    if (node["x-mode"]) {
      _clone2["x-mode"] = node["x-mode"];
    }
    result = _clone2;
  } else if (isDirective(node)) {
    var instruction = new ProcessingInstruction(node.name, node.data);
    if (node["x-name"] != null) {
      instruction["x-name"] = node["x-name"];
      instruction["x-publicId"] = node["x-publicId"];
      instruction["x-systemId"] = node["x-systemId"];
    }
    result = instruction;
  } else {
    throw new Error("Not implemented yet: ".concat(node.type));
  }
  result.startIndex = node.startIndex;
  result.endIndex = node.endIndex;
  if (node.sourceCodeLocation != null) {
    result.sourceCodeLocation = node.sourceCodeLocation;
  }
  return result;
}
export { _cloneNode as cloneNode };
function cloneChildren(childs) {
  var children = childs.map(function (child) {
    return _cloneNode(child, true);
  });
  for (var i = 1; i < children.length; i++) {
    children[i].prev = children[i - 1];
    children[i - 1].next = children[i];
  }
  return children;
}